import { render } from "./CreateGuiTheme.vue?vue&type=template&id=caad6204&scoped=true"
import script from "./CreateGuiTheme.vue?vue&type=script&lang=js"
export * from "./CreateGuiTheme.vue?vue&type=script&lang=js"

import "./CreateGuiTheme.vue?vue&type=style&index=0&id=caad6204&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caad6204"]])

export default __exports__